module.exports = __webpack_public_path__ + "static/media/school_14.b0c08bdf.png";